import { render, staticRenderFns } from "./DyoProducts.vue?vue&type=template&id=7b5f6e90&"
import script from "./DyoProducts.vue?vue&type=script&lang=js&"
export * from "./DyoProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports